import { useNavigate } from 'react-router-dom';
import { DIFERENCIAIS, PLATAFORMA_DIFERENCIAL_IMG } from '../data';

export default function PlataformaDiferencial() {
  const navigate = useNavigate();

  return (
    <section id="diferenciais" className="scroll-mt-28 bg-secondary-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="grid items-center gap-12 lg:grid-cols-[0.78fr_1.22fr] lg:gap-14">
          <div>
            <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
              Por que tudo em um
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-4xl">
              Menos ferramentas,
              <br />
              <span className="text-primary-600">mais resultado</span>
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-foreground-600">
              Em vez de montar um quebra-cabeça de sistemas, a GetPoints entrega tudo o que o seu programa
              precisa em um único lugar — com a menor taxa do mercado e conformidade regulatória desde o início.
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              {DIFERENCIAIS.map((item) => (
                <div key={item.title} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.description}</p>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={() => navigate('/solicitar-demo')}
              className="mt-9 inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              Fale com um especialista
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>

          <div className="relative">
            <img
              src={PLATAFORMA_DIFERENCIAL_IMG}
              alt="Painel unificado da plataforma GetPoints mostrando campanhas, gamificação e recompensas em notebook e celular"
              title="Plataforma GetPoints - tudo em um"
              className="block h-auto w-full object-contain lg:scale-[1.06]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}